


















import {
	computed,
	defineComponent,
	PropType,
	reactive,
	toRefs,
	watch,
} from '@vue/composition-api';
import CategoriesInput from '@front-app/components/inputs/CategoriesInput.vue';
import { FullUser, Specialty } from '@front-app/services/UserApi/UserModel';
import { UserProfileOptionsStore } from '@front-app/store/singletons/UserProfileOptions';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { CurrentUserStore } from '@front-app/store/singletons/User';
import EditorWrapper from '../../layouts/form/EditorWrapper.vue';

interface SpecialtiesState {
	specialties: string[];
}

export default defineComponent({
	components: {
		CategoriesInput,
		EditorWrapper,
	},
	props: {
		user: {
			type: Object as PropType<FullUser>,
			required: true,
		},
	},
	setup(props) {
		const { update } = CurrentUserStore.actions;

		const state: SpecialtiesState = reactive({
			specialties: [],
		});
		const actualSpecialties = computed(() => props.user.specialties);
		watch(actualSpecialties, (curr: string[]) => {
			state.specialties = [...curr] || [];
		}, { immediate: true });
		const addSpecialty = (newSpecialty: string) => {
			state.specialties.push(newSpecialty);
		};
		const removeSpecialty = (oldSpecialty: string) => {
			state.specialties = state.specialties.filter((val) => val !== oldSpecialty);
		};

		const allSpecialties = computed(() => UserProfileOptionsStore.specialties.value.map(({ name }) => name));

		const {
			track,
			clear,
			isLoading,
			isError,
			isSuccess,
		} = useAsyncStatus();
		const saveUser = async () => {
			// This is a cool n^2 time, but probably doesn't matter for this use case
			const specialties = state.specialties
				.map(UserProfileOptionsStore.getSpecialtyByName)
				.filter((item): item is Specialty => item !== undefined)
				.map(({ specialtyId }) => specialtyId);

			await track(update({
				specialties: {
					specialties,
				},
			}));
			clear(4000);
		};
		return {
			saveUser,
			isLoading,
			isError,
			isSuccess,
			allSpecialties,
			addSpecialty,
			removeSpecialty,
			...toRefs(state),
		};
	},
});
